export default "/images/pensam.webp?06edf87ffb1201e2b3c42888cc40fe27";